import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { businessInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-white rounded-full p-3 shadow-2xl ring-4 ring-cyan-400/20">
                <img 
                  src={businessInfo.logo}
                  alt={businessInfo.name}
                  className="w-28 h-28 object-contain"
                />
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Your trusted partner for premium pool and spa services in Texas. 
              Creating backyard oases since 2010.
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 hover:bg-cyan-500 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Services', 'About', 'Gallery', 'Testimonials', 'Contact'].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => scrollToSection(link.toLowerCase())}
                    className="text-gray-400 hover:text-cyan-400 transition-colors duration-200 text-sm"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Our Services</h4>
            <ul className="space-y-3">
              <li className="text-gray-400 text-sm hover:text-cyan-400 transition-colors duration-200 cursor-pointer">
                Custom Pool Design & Installation
              </li>
              <li className="text-gray-400 text-sm hover:text-cyan-400 transition-colors duration-200 cursor-pointer">
                Luxury Spa Installation
              </li>
              <li className="text-gray-400 text-sm hover:text-cyan-400 transition-colors duration-200 cursor-pointer">
                Pool Repair Services
              </li>
              <li className="text-gray-400 text-sm hover:text-cyan-400 transition-colors duration-200 cursor-pointer">
                Maintenance & Cleaning
              </li>
              <li className="text-gray-400 text-sm hover:text-cyan-400 transition-colors duration-200 cursor-pointer">
                Equipment Upgrades
              </li>
              <li className="text-gray-400 text-sm hover:text-cyan-400 transition-colors duration-200 cursor-pointer">
                24/7 Emergency Service
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-6">Get In Touch</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${businessInfo.phone}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-cyan-400 transition-colors duration-200 group"
                >
                  <Phone className="w-5 h-5 mt-0.5 group-hover:scale-110 transition-transform duration-200" />
                  <div>
                    <div className="text-xs text-gray-500">Call Us</div>
                    <div className="text-sm font-semibold">{businessInfo.phone}</div>
                  </div>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${businessInfo.email}`}
                  className="flex items-start gap-3 text-gray-400 hover:text-cyan-400 transition-colors duration-200 group"
                >
                  <Mail className="w-5 h-5 mt-0.5 group-hover:scale-110 transition-transform duration-200" />
                  <div>
                    <div className="text-xs text-gray-500">Email Us</div>
                    <div className="text-sm font-semibold break-all">{businessInfo.email}</div>
                  </div>
                </a>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="w-5 h-5 mt-0.5" />
                <div>
                  <div className="text-xs text-gray-500">Location</div>
                  <div className="text-sm font-semibold">{businessInfo.address}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} {businessInfo.name}. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <a href="#" className="hover:text-cyan-400 transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-cyan-400 transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="hover:text-cyan-400 transition-colors duration-200">
                Sitemap
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
